import type { ReactNode } from "react";
import { useAccent } from "./accent";

interface GradientTextProps {
  children: ReactNode;
  /** Override gradient stops; defaults to the current chapter accent. */
  from?: string;
  to?: string;
  className?: string;
}

export function GradientText({ children, from, to, className = "" }: GradientTextProps) {
  const accent = useAccent();
  return (
    <span
      className={`bg-clip-text text-transparent ${className}`}
      style={{
        backgroundImage: `linear-gradient(90deg, ${from ?? accent[0]}, ${to ?? accent[1]})`,
      }}
    >
      {children}
    </span>
  );
}
